module.exports = __webpack_public_path__ + "static/media/italy_paper_mill_getty_tablet.d7458576.jpg";